module.exports = __webpack_public_path__ + "img/main_logo.5830e150.svg";